import { SerializedSmartLinkStatus } from 'fym-common/src/db/serializersTypes';

export function isSmartLinkDraft(smartLink: { recentSmartLinkVersion: { status: SerializedSmartLinkStatus } }) {
  return smartLink.recentSmartLinkVersion.status === SerializedSmartLinkStatus.draft;
}
